export { PageVisibleState } from './metric/base-metric';
export let BMEventsType;

(function (BMEventsType) {
  BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
  BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
  BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
  BMEventsType["CUSTOM"] = "CUSTOM";
  BMEventsType["WEB_VITALS"] = "WEB_VITALS";
})(BMEventsType || (BMEventsType = {}));

export let StorableBMEventsType;

(function (StorableBMEventsType) {
  StorableBMEventsType["PAGE_LOAD"] = "page-load";
  StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
  StorableBMEventsType["INLINE_RESULT"] = "inline-result";
  StorableBMEventsType["CUSTOM"] = "custom";
  StorableBMEventsType["WEB_VITALS"] = "web-vitals";
})(StorableBMEventsType || (StorableBMEventsType = {}));

export let BMPageLoadMetrics;

(function (BMPageLoadMetrics) {
  BMPageLoadMetrics["fmp"] = "fmp";
  BMPageLoadMetrics["tti"] = "tti";
})(BMPageLoadMetrics || (BMPageLoadMetrics = {}));

export let BMPageSegmentLoadMetrics;

(function (BMPageSegmentLoadMetrics) {
  BMPageSegmentLoadMetrics["fmp"] = "fmp";
  BMPageSegmentLoadMetrics["tti"] = "tti";
})(BMPageSegmentLoadMetrics || (BMPageSegmentLoadMetrics = {}));

export let BMInteractionMetrics;

(function (BMInteractionMetrics) {
  BMInteractionMetrics["response"] = "response";
  BMInteractionMetrics["result"] = "result";
})(BMInteractionMetrics || (BMInteractionMetrics = {}));

export let PageSegmentPageLoadMetricsOptions;

(function (PageSegmentPageLoadMetricsOptions) {
  PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
  PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
  PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
})(PageSegmentPageLoadMetricsOptions || (PageSegmentPageLoadMetricsOptions = {}));

export let PageVisibleFields;

(function (PageVisibleFields) {
  PageVisibleFields["pageVisibleState"] = "page-visible-state";
  PageVisibleFields["pageVisibleValue"] = "page-visible-value";
})(PageVisibleFields || (PageVisibleFields = {}));

export let PageVisibleValueOrigin;

(function (PageVisibleValueOrigin) {
  PageVisibleValueOrigin["documentHidden"] = "document-hidden";
  PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
})(PageVisibleValueOrigin || (PageVisibleValueOrigin = {}));

export const isDetailedPageLoadSlo = data => {
  return Boolean(data.initial);
};
export const isDetailedPageSegmentLoadSlo = data => {
  return Boolean(data.initial);
};
export const isPageLoadMetricsSlo = data => {
  const obj = data;
  return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
export const isInteractionMetricsSlo = data => {
  const obj = data;
  return Boolean(obj.result !== undefined || obj.response !== undefined);
};
export let IncludeSSRFeatureFlagsConfig;

(function (IncludeSSRFeatureFlagsConfig) {
  IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
  IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
  IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
})(IncludeSSRFeatureFlagsConfig || (IncludeSSRFeatureFlagsConfig = {}));